<template>
  <div>
    <!-- Start 通用返回 -->
    <Back title="购课信息确认"></Back>
    <div class="new-sign">
        <SchoolCenter
            v-if="classInfo"
            :classInfo="classInfo"
            :schoolList = "schoolList"
        ></SchoolCenter>

        <!--选择上课周期 start-->
        <div class="section-header pt20 pl30 pb10 clearfix">
            <b class="section-name fl">上课时间</b>
            <span class="section-notice fl">选择上课时间</span>
            <span v-if="timesheetInfo.canStage == 0 && datesGroupSelectedStart||(timesheetInfo.rate === NewSignCourseRateEnum.Unlimit&&hasSelectedTimeInfo)" class="repick-date-btn fr" @click="openMonthlyDatePicker">
              重新选择
            </span>
        </div>

        <!--分期长期课 针对有stageRangeList的类型或canStage类型-->

        <StagePicker
            v-if="timesheetInfo.canStage == 1 && stageRangeList.length > 0"
            :stageRangeList="stageRangeList"
            @onStageChange="onStageChange">
        </StagePicker>

            <!--非分期课 start-->

            <!--七天一次课 start-->
            <div v-if="timesheetInfo.canStage == 0 && timesheetInfo.rate == NewSignCourseRateEnum.Weekly" class="time-line-wrap pt25">
              <DateGroupWeeklyCard
                :datesGroupSelectedStart = "datesGroupSelectedStart"
                :datesGroupSelectedEnd = "datesGroupSelectedEnd"
                @openMonthlyDatePicker = "openMonthlyDatePicker">
              </DateGroupWeeklyCard>
            </div>

            <MultiMonthlyDatePicker
                v-if="startDate && endDate && timesheetInfo.datesGroup && timesheetInfo.canStage === 0 && timesheetInfo.rate !== NewSignCourseRateEnum.Unlimit"
                :openDatesPicker="openDatesPicker"
                :rate="timesheetInfo.rate"
                :startDate="startDate"
                :endDate="endDate"
                :datesGroup = "timesheetInfo.datesGroup"
                :selectMode = "timesheetInfo.selectMode"
                :groupLimit = "timesheetInfo.groupLimit"
                @onSaveGroupIdsHandler = "onSaveDateGroupIdsHandler"
                @onCloseDatePicker = "closeMonthlyDatePicker"
            >
            </MultiMonthlyDatePicker>
            <!--七天一次课 end-->

            <!--非分期课 end-->
            <!--不分期非规律性上课 start-->
            <div class="choose-time irr-choose-time ptb30 txt-center" 
                  v-if="timesheetInfo.canStage === 0 && timesheetInfo.rate === NewSignCourseRateEnum.Unlimit">
                  <IrrSelectedTimes
                      v-if="hasSelectedTimeInfo"
                  ></IrrSelectedTimes>
                  <p @click="openMonthlyDatePicker" v-else class="tip ptb10">选择上课时间</p>
            </div>
            <IrrMultiMonthlyDatePicker
                v-if="startDate && endDate && timesheetInfo.datesGroup && timesheetInfo.canStage === 0 && timesheetInfo.rate === NewSignCourseRateEnum.Unlimit"
                :openDatesPicker="openDatesPicker"
                :rate="timesheetInfo.rate"
                :startDate="startDate"
                :endDate="endDate"
                :datesGroup = "timesheetInfo.datesGroup"
                :selectMode = "timesheetInfo.selectMode"
                :groupLimit = "timesheetInfo.groupLimit"
                :minSelectLimit = "timesheetInfo.minSelectLimit"
                @onSaveDateGroupIdsHandler = "onSaveIrrDateGroupIdsHandler"
                @onCloseDatePicker = "closeMonthlyDatePicker"
            >
            </IrrMultiMonthlyDatePicker>
            <!--不分期非规律性上课 end-->

            <!--选择上课周期 end-->

            <!--规律性上课选择上课时段  start-->
            <div class="section-header pt20 plr30 pb10" v-if="timesheetInfo.rate !== NewSignCourseRateEnum.Unlimit">
                <b class="section-name">上课时段</b>
                <span class="section-notice">选择每日意向上课时段</span>
            </div>
            <PeriodPicker
                v-if="timesheetInfo.rate !== NewSignCourseRateEnum.Unlimit"
                :rate="timesheetInfo.rate"
                :startDate="datesGroupSelectedStart&&datesGroupSelectedStart.date"
                :endDate="datesGroupSelectedEnd&&datesGroupSelectedEnd.date"
                :list="timesheetInfo.periods"
                :datesGroup="timesheetInfo.datesGroup"
                :groupId="datesGroupSelectedStart && datesGroupSelectedStart.groupId"
            ></PeriodPicker>
            <!--规律性上课选择上课时段 end-->

            <div class="bottom-actions">
                <a class="btn-submit btn-origin" @click="submitOrder">确定下单</a>
            </div>
            <!--待支付订单弹框-->
            <div class="dialog-bg vcbox notPayOrder-dialog" v-if="notPayOrderDialog" @click.self="notPayOrderDialog = false">
              <div class="dialog">
                <div class="dialog-con">
                  <p class="info">您有一笔未完成订单，请继续<br/>支付</p>
                  <p class="notPayOrder-dialog-btn-box">
                    <a href="javascript:void(0)" @click="toOrderDetail">查看详情</a>
                  </p>
                </div>
              </div>
            </div>
            <!--爱智康下载-->
            <div class="dialog-bg vcbox appDown-dialog" v-if="appDownDialogShow" @click.self="appDownDialogShow = false">
              <div class="dialog">
                <div class="dialog-con">
                  <p class="info">购课前先要进行入学诊断，请下载<br/>爱智康APP进行分数评测</p>
                  <p class="appDown-dialog-btn-box">
                    <a href="javascript:void(0)" @click="download">立即下载</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="dialog-bg vcbox notPayOrder-dialog" v-if="cityNotCompliantDialog" @click.self="closeCityNotCompliantDialog">
              <div class="dialog">
                <div class="dialog-con">
                  <p class="info">您当前所选城市无法购买此课程<br/>前往查看适合您的课程</p>
                  <p class="notPayOrder-dialog-btn-box">
                    <a href="javascript:void(0)" @click="toCourse">确认</a>
                  </p>
                </div>
              </div>
            </div>
      </div>
  </div>
</template>
<script>
/**
 * 课程新签 时段与校区选择
 */
import PeriodPicker from './PeriodPicker'
import SchoolCenter from './SchoolCenter'
import DateGroupWeeklyCard from './DateGroupWeeklyCard'
import MultiMonthlyDatePicker from './MultiMonthlyDatePicker'
import IrrMultiMonthlyDatePicker from './IrrMultiMonthlyDatePicker'
import StagePicker from './StagePicker'
import IrrSelectedTimes from './IrrSelectTimes'
import {mapState} from 'vuex'
import api from '@/common/libs/api'
import _ from 'lodash'
import './index.less'
import utils from '@/common/libs/utils'
import Back from '@/components/public/back/Back.vue'
import CityCodeData from '@/common/libs/CityCodeData';

export default {
  name: 'NewSign',
  components: {
    PeriodPicker,
    SchoolCenter,
    DateGroupWeeklyCard,
    MultiMonthlyDatePicker,
    StagePicker,
    IrrMultiMonthlyDatePicker,
    IrrSelectedTimes,
    Back
  },
  computed: mapState({
    stageRangeList: state => state.newsign.stageRangeList,
    dateRangeList: state => state.newsign.dateRangeList,
    timesheetInfo: state => state.newsign.timesheetInfo,
    submitForm: state => state.newsign.submitForm,
    classInfo: state => state.newsign.classInfo,
    schoolList: state => state.newsign.schoolInfo,
    hasSelectedTimeInfo: state => _.keys(state.newsign.irrSelectedTimeInfo).length>0,
    currentOrderResult: state => state.newsign.currentOrderResult,
    studentCityCode: state => state.newsign.studentCityCode,
    cityNotCompliantDialog: state => state.newsign.cityNotCompliantDialog
  }),
  data(){
    return {
      datesGroupSelectedStart: null,
      datesGroupSelectedEnd: null,
      openDatesPicker: false,
      bizId: '',
      startDate: '',
      endDate: '',
      periodTime: '',
      NewSignCourseRateEnum: api.CodeMap.NewSignCourseRateEnum,
      irrDateGroupCells: [], //定制课时段选择
      notPayOrderDialog: false,
      appDownDialogShow: false
    }
  },
  watch: {
    dateRangeList(){
      var startDate = this.dateRangeList.length>0&&this.dateRangeList[0].startDate;
      var endDate = this.dateRangeList.length>0&&this.dateRangeList[this.dateRangeList.length - 1].endDate;
      this.startDate = startDate;
      this.endDate = endDate;
      if (this.stageRangeList.length > 0) { //是期课
        this.$store.dispatch('fetchTimeSheet', {
          stage: '1',
          stageStart: this.stageRangeList[0].startDate,
          stageEnd: this.stageRangeList[0].endDate,
          bizId: this.bizId,
          startDate: this.stageRangeList[0].startDate,
          endDate: this.stageRangeList[0].endDate
        });
      } else { //非期课
        this.$store.dispatch('fetchTimeSheet', {
          bizId: this.bizId,
          startDate: startDate,
          endDate: endDate,
          stage: '0'
        });
      }
    },
    //提交订单后，返回的结果
    currentOrderResult(){
        
        if (!this.currentOrderResult.orderSuccess){ //下单失败  
            if (this.currentOrderResult.notPayOrderInfo) { //存在待支付订单
                this.notPayOrderDialog = true;
            } else {
                this.appDownDialogShow = true; //不符合报班资格  
            }
        } else if (this.currentOrderResult.orderInfo.orderId){
            console.log('跳转到订单详情：', this.currentOrderResult.orderInfo.orderId);
            this.toPay(this.currentOrderResult.orderInfo.orderStatus, this.currentOrderResult.orderInfo.orderId, this.currentOrderResult.orderInfo.payChannelCode);
        }
    }
  },
  methods: {
    /**
     * 选择期发生变化，获取时段详情，选择约束均根据此数据处理
     * 当stage为1时，需要分期
     * 当stage为0时，不需要分期
     * */
    onStageChange(stage){
      this.startDate = stage.startDate;
      this.endDate = stage.endDate;
      var params = {
        bizId: this.bizId,
        stage: '1',
        stageStart: stage.startDate,
        stageEnd: stage.endDate,
        startDate: stage.startDate,
        endDate: stage.endDate
      };
      this.$store.dispatch('fetchTimeSheet', params);
    },
    /**
     * 确认选择的日期范围，非期课模式用
     * */
    onSaveDateGroupIdsHandler(datesGroupSelected){
      var first = _.first(datesGroupSelected);
      var last = _.last(datesGroupSelected)
      var periodTime = "";
      if (!first||!last){
        this.openDatesPicker = false;
        return;
      }
      for (var i = 0; i < this.timesheetInfo.periods.length; i++) {
        var period = this.timesheetInfo.periods[i];
        if (period.disabledDateGroupIds.indexOf(first.date) == -1) {
          periodTime = period.time;
          break;
        }
      }
      this.openDatesPicker = false;
      this.datesGroupSelectedStart = first;
      this.datesGroupSelectedEnd = last;
      this.periodTime = periodTime;
    },
    /**
     * 确定选择的日期和时段，定制课类型用
     */
    onSaveIrrDateGroupIdsHandler(periodSelected){
        this.openDatesPicker = false;
        var groupInfos = _.flatten(_.values(periodSelected));
        if (!this.submitForm.schoolId){
          this.$store.dispatch('toast', {title: '请先选择学习中心', show: true});
          return;
        }
        this.irrDateGroupCells = _.map(groupInfos, item => {
          return {
            dateFormat: item.dateFormat,
            dateValue: item.dateValue,
            dateText: item.selectText,
            productId: this.bizId,
            schoolId: this.submitForm.schoolId,
            type: 1
          }
        });
        console.log('不规律选择：', groupInfos);
    },
    submitOrder(){
      
        var cellsToSubmit = [];
       if (!this.submitForm.schoolId&&this.classInfo.teachMode==1) {
            this.$store.dispatch('toast', {title: '学习中心不可为空', show: true});
            return;
        }
        if (this.timesheetInfo.rate!==api.CodeMap.NewSignCourseRateEnum.Unlimit&&!this.submitForm.periodTime) {
            this.$store.dispatch('toast', {title: '请选择上课时段', show: true});
            return;
        }
        if (this.timesheetInfo.rate == api.CodeMap.NewSignCourseRateEnum.Weekly && !this.datesGroupSelectedStart) {
            this.$store.dispatch('toast', {title: '请选择上课时间', show: true});
            return;
        }
        if (this.timesheetInfo.canStage) {
            /**分期课，取相同groupId的数据*/
            cellsToSubmit = _.filter(this.timesheetInfo.cells, (cell) => {
                if (this.submitForm.periodTime == cell.time && cell.date >= this.startDate && cell.date <= this.endDate && cell.canSelect) {
                    return true;
                } else {
                    return false;
                }
            });
        } else if (this.timesheetInfo.rate == api.CodeMap.NewSignCourseRateEnum.Weekly) {
            /**非期课，取相同groupId的数据*/
            var date = this.datesGroupSelectedStart.date;
            var groupInfo = _.find(this.timesheetInfo.cells, {date: date, time: this.submitForm.periodTime});
            cellsToSubmit = _.filter(this.timesheetInfo.cells, {groupId: groupInfo.groupId, date: date, canSelect: 1});
        } else if (this.timesheetInfo.rate === api.CodeMap.NewSignCourseRateEnum.Unlimit){
           cellsToSubmit = this.irrDateGroupCells;
           console.log('cellsToSubmit:', this.irrDateGroupCells);
        }
        if (cellsToSubmit.length == 0) {
            this.$store.dispatch('toast', {title: '请先选择上课信息', show: true});
            return;
        }
        this.$store.commit('setSubmitForm', {
            type: this.$route.query.type.toString(),
            bizId: this.bizId,
            groupInfo: this.timesheetInfo.rate=== api.CodeMap.NewSignCourseRateEnum.Unlimit?cellsToSubmit:[{
                productId: this.bizId,
                schoolId: this.submitForm.schoolId,
                dateFormat: cellsToSubmit[0].dateFormat,
                dateValue: cellsToSubmit[0].dateValue,
                dateText: cellsToSubmit[0].selectText,
                type: this.$route.query.type.toString()
            }]
        });
        this.$store.dispatch('submitNewSign');
    },
    openMonthlyDatePicker(){
      if (!this.submitForm.schoolId){
        this.$store.dispatch('toast', {title: '请先选择学习中心', show: true});
        return;
      }
      this.openDatesPicker = true;
    },
    closeMonthlyDatePicker(){
      this.openDatesPicker = false;
    },
    /**
     * 待支付订单-查看详情
     * */
    toOrderDetail(){
        if (this.currentOrderResult.notPayOrderInfo && this.currentOrderResult.notPayOrderInfo.id) {
            this.toPay(this.currentOrderResult.notPayOrderInfo.status, this.currentOrderResult.notPayOrderInfo.id, this.currentOrderResult.notPayOrderInfo.payChannelCode);
        }
    },
    //跳转至支付h5页面
    toPay(orderStatus, orderId, payChannelCode) {
        let url = '';
        let type = 0; //支付类型 0：付全款 1：付定金 2：付尾款
        if (orderStatus == 5) { //订单状态 0:待支付 1:已取消 2:已失效 3:已支付 4:已退单 5:待支付-已缴定金 6:分期待付 7:分期中断
            type = 2;
        } else {
            type = 0;
        }
        let mUrl = 'beta-m.izhikang.com'
        if (process.env.NODE_ENV =='production') {
          mUrl = 'm.izhikang.com';
        } else if (process.env.NODE_ENV =='development'){
          mUrl = 'dev-m.izhikang.com';
        } else if (process.env.NODE_ENV =='beta'){
          mUrl = 'beta-m.izhikang.com';
        } else if (process.env.NODE_ENV =='audit'){
          mUrl = 'audit-m.izhikang.com';
        }

        var queryStr = utils.jsonToSerializer({
          type: type,
          payChannelCode: payChannelCode,
          orderId: orderId,
          MStationUrl: `${mUrl}/${this.$route.params.city}/course/class`,
          cityCode: utils.cookie.get('cityCode')||'010'
        });
        
        if (process.env.NODE_ENV =='production') {
          url = `https://mlecture.izhikang.com/h5pay/orderDetail?${queryStr}`;
        } else if (process.env.NODE_ENV =='development'){
          url = `https://dev-mlecture.izhikang.com/h5pay/orderDetail?${queryStr}&timestamp=${Date.now().valueOf()}`;
        } else if (process.env.NODE_ENV =='beta'){
          url = `https://beta-mlecture.izhikang.com/h5pay/orderDetail?${queryStr}&timestamp=${Date.now().valueOf()}`;
        } else if (process.env.NODE_ENV =='audit'){
          url = `https://pre-mlecture.izhikang.com/h5pay/orderDetail?${queryStr}&timestamp=${Date.now().valueOf()}`;
        }
        // window.location.replace(url);
        window.location.href = url;
    },
    //爱智康下载
    download() {
        this.$router.push({name: 'download'});
    },
    //城市不符合时跳转到选课中心
    toCourse() {
        let city = {};
        if (this.studentCityCode == '0086') {
            city = CityCodeData.getCityByCode('010');
            
            this.$router.push({
                name: 'online',
                params: {
                    city: 'bj'
                }
            });
            utils.cookie.set('cardChangeCity', 0, '.izhikang.com', '/', 24*7);
        } else {
            city = CityCodeData.getCityByCode(this.studentCityCode);
            this.$router.push({
                name: 'courses',
                params: {
                    city: city.first_word
                }
            });
            utils.cookie.set('cardChangeCity', 1, '.izhikang.com', '/', 24*7);
        }
        this.$store.commit('setCity', city);
        utils.cookie.set('cityCode', city.city_code, '.izhikang.com', '/', 24*7);
        utils.cookie.set('canSwitchCity', 0, '.izhikang.com', '/', 24*7);                
        this.$store.commit('changeCityNotCompliantDialog', false);
    },
    //关闭城市弹框
    closeCityNotCompliantDialog() {
        this.$store.commit('changeCityNotCompliantDialog', false);
    }
  },
  destroyed(){
    document.body.className = ""
  },
  mounted(){
    let curRouter = {
      name: this.$route.name,
      query: this.$route.query,
      params: this.$route.params
    };
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
    this.bizId = this.$route.query.bizId;
    this.$store.dispatch('fetchCourseInfo', {bizId: this.bizId, toRouterQuery: curRouter});
    this.$store.dispatch('fetchDateRange', {bizId: this.bizId, toRouterQuery: curRouter});
    document.body.className = "body-no-move"
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/index.vue